import { RepositoryService } from '@_services/api/repository.service';
import { Profil } from '@_model/interfaces/profil.model';
import { Observable } from 'rxjs';

export class GeneratedProfilApiService {
  constructor(protected repo: RepositoryService) {}

  public getProfils(params?: any): Observable<Profil[]> {
    return this.repo.getData<Profil[]>('profil', params);
  }

  public getProfil(params: { idProfil: number; params?: any }): Observable<Profil> {
    return this.repo.getData<Profil>('profil/' + params.idProfil, params.params);
  }

  public addProfil(profil: Partial<Profil>): Observable<Profil> {
    return this.repo.create<Profil>('profil', profil);
  }

  public updateProfil(profil: Partial<Profil>): Observable<Profil> {
    return this.repo.update('profil', profil);
  }

  public deleteProfil(idProfil: number): Observable<number> {
    return this.repo.delete('profil/' + +idProfil);
  }
}
